import Big from 'big.js';
import axios from 'smg/axios';
import * as session from 'smg/customer-api/session';
import * as models from 'smg/models';
import { G } from 'smg/querystring';
import * as template from 'smg/template';
import { DollarFormat } from 'smg/util';
import { PromptPayment } from '../payments';

declare interface orderResp {
    order: models.Order;
}

export default async function main() {
    const sess = await session.Session().catch(() => undefined);

    function showNotFound() {
        const orderFoundContainer = document.querySelector('#order-found-container') as HTMLElement;
        const notFoundWrapper = document.querySelector('.not-found-wrapper') as HTMLElement;
        const bannerContainer = document.querySelector('main') as HTMLElement;

        orderFoundContainer.classList.add('d-none');
        notFoundWrapper.classList.remove('d-none');
        if (bannerContainer.parentElement) {
            bannerContainer.parentElement.style.backgroundImage = 'url("/bg-banner.png")'; // TODO: Use relref when depot index/homepage is in hugo
            bannerContainer.parentElement.style.backgroundSize = 'cover';
            bannerContainer.parentElement.style.marginBottom = '20rem';
            bannerContainer.parentElement.style.height = '500px';
        }

        const spinner = document.querySelector('#spinner');
        spinner?.classList.add('d-none');
    }

    const proofContainer = document.querySelector('#proof-container') as HTMLElement;
    const invoiceNumber = document.querySelector('#invoice-number') as HTMLElement;
    const orderTotal = document.querySelector('#order-total') as HTMLElement;
    const paymentAmount = document.querySelector('#payment-amount') as HTMLElement;
    const makePaymentBtn = document.querySelector('#make-payment-btn') as HTMLButtonElement;
    const noBalanceAlert = document.querySelector('#no-balance-alert') as HTMLElement;
    const paymentSuccessContainer = document.querySelector('#payment-success') as HTMLElement;
    const paymentSuccessAmount = document.querySelector('#payment-success-amount') as HTMLElement;
    const prePaymentContainer = document.querySelector('#pre-payment-container') as HTMLElement;

    const orderID = G().Get('order');
    let paymentDue = G().Get('amount');

    if (!orderID) {
        showNotFound();
        return;
    }

    axios.get<orderResp>(`/orders/${orderID}`).
        then(resp => {
            const order = resp.data.order;

            const balance = Big(order.balance || 0);

            const hasBalance = balance.gte('0.05');

            if (!hasBalance) {
                paymentAmount.parentElement?.classList.add('d-none');
                makePaymentBtn.classList.add('d-none');
                noBalanceAlert.classList.remove('d-none');
            }

            if (!paymentDue) {
                paymentDue = order.balance;
            }

            if (Big(paymentDue || '').gt(balance)) {
                paymentDue = balance.toString();
            }

            invoiceNumber.textContent = order.invoiceNumber?.toString() || '';
            orderTotal.textContent = DollarFormat(order.total || Big('0'));
            paymentAmount.textContent = DollarFormat(paymentDue || order.balance || Big('0'));

            for (const orderProof of order.orderProofs || []) {
                const proofEl = template.Clone('#proof-template');
                const imgEl = proofEl.querySelector('img') as HTMLImageElement;
                const anchorEl = proofEl.querySelector('a') as HTMLAnchorElement;

                anchorEl.href = orderProof?.proof?.main || '';
                anchorEl.dataset.caption = orderProof?.proof?.name;

                imgEl.src = orderProof?.proof?.main || '';

                proofContainer?.append(proofEl);
            }

            makePaymentBtn.addEventListener('click', async () => {
                await PromptPayment(sess, [order.id || ''], Big(paymentDue || 0), true).then(() => {
                    prePaymentContainer.classList.add('d-none');
                    paymentSuccessContainer.classList.remove('d-none');
                    paymentSuccessAmount.textContent = DollarFormat(paymentDue || Big('0'));
                });
            });
        }).catch(err => {
            showNotFound();
            console.error(err);
        });

    const spinner = document.querySelector('#spinner');
    const orderFoundContainer = document.querySelector('#order-found-container');
    spinner?.classList.add('d-none');
    orderFoundContainer?.classList.remove('d-none');
}